export const API = 'https://halo.streamerr.co/api/nowplaying/116';
export const API_STREAM_DATA = 'https://beveikradijas.com/stream_data.php';
export const API_DEEZER_SEARCH = 'https://beveikradijas.com/stream_image.php';
